const round4 = (val) => Math.round(val * 1e4) / 1e4;

export default round4;
